import React, { Suspense, lazy, useState } from 'react';

// The world map brings its own shapes, so it is loaded only when a report has places to show.
// If it cannot be loaded (a lost connection, or an update published while the page was open) that must not take
// the rest of the analytics page down with it: it says so and offers to try again.
class MapLoadFailure extends React.Component {
    state = { failed: false };

    static getDerivedStateFromError() {
        return { failed: true };
    }

    componentDidCatch(error) {
        console.error('Could not load the guest map:', error);
    }

    render() {
        if (!this.state.failed) return this.props.children;
        return this.props.fallback(() => this.setState({ failed: false }));
    }
}

export default function GuestMapSection({ places, unknown = 0, load = () => import('./GuestPlaces') }) {
    const [LoadedMap, setLoadedMap] = useState(() => lazy(load));
    return <MapLoadFailure fallback={retry => <p role="alert" className="dc-analytics-error">
        The map could not be loaded. <button type="button" onClick={() => { setLoadedMap(() => lazy(load)); retry(); }}>Try again</button>
    </p>}>
        <Suspense fallback={<p role="status" data-report-pending="true" className="dc-analytics-empty">Loading map…</p>}>
            <LoadedMap places={places} unknown={unknown} />
        </Suspense>
    </MapLoadFailure>;
}
